export default "__VITE_ASSET__Dz_CZw_o__"